export const BADGE_TYPE_MAP = {
  productLine: 'new',
  productsAdded: 'new',
  badgeNew: 'new',
  badgeFeatured: 'featured',
  badgeBestSeller: 'best-seller',
  badgeBestValue: 'best-value',
  badgeBestPerformance: 'best-performance',
};
